import React from 'react';

import Plus from '@ast/magma/components/icon/icons/Plus';

import { Button } from '@ast/magma/components/button';

import { Passkey } from '@app/queryTyping';

import { useUserSettingsTranslation } from '@app/widgets/contacts-and-settings/hooks/useUserSettingsTranslation';

import { PasskeyItem } from './PasskeyItem';
import styles from './PasskeyList.pcss';

export interface PasskeyListProps {
  isLoadingRevokePasskey: boolean;
  passkeyRevokeError: string;
  registeredPasskeys: Passkey[];
  handleStartRegistration: () => void;
  onDeletePasskey: (passkeyId: string) => Promise<unknown>;
}

export const PasskeyList: React.FC<PasskeyListProps> = ({
  isLoadingRevokePasskey,
  passkeyRevokeError,
  registeredPasskeys,
  handleStartRegistration,
  onDeletePasskey,
}) => {
  const { t } = useUserSettingsTranslation();

  return (
    <div className={styles.passkeyListContainer}>
      <div>
        <Button
          look="link"
          predefinedSize="large"
          data-stable-name="RegisterButton"
          onClick={() => handleStartRegistration()}
          icon={<Plus />}
        >
          {t('profile-and-security.passkey-list.add-passkey|Add passkey button', 'Add a passkey')}
        </Button>
      </div>
      {registeredPasskeys && registeredPasskeys?.length > 0 && (
        registeredPasskeys.map((passkey) => (
          <PasskeyItem
            key={passkey.id}
            isLoadingRevokePasskey={isLoadingRevokePasskey}
            passkeyRevokeError={passkeyRevokeError}
            passkey={passkey}
            onDeletePasskey={() => onDeletePasskey(passkey.id)}
          />
        ))
      )}
    </div>
  );
};
